<template>
    <div id="create-purchase-order-form">
        <b-row>
            <b-col>
                <SearchComponent v-model="order.store"
                    label="Store"
                    search-u-r-l="/Store"
                    prepopulate
                    clearable
                    required />
            </b-col>
            <b-col>
                <SearchComponent v-model="order.vendor"
                    label="Vendor"
                    search-u-r-l="/Vendor"
                    prepopulate
                    clearable
                    required />
            </b-col>
        </b-row>
        <b-row>
            <b-col>
                <SearchComponent v-model="program"
                    label="Program"
                    search-u-r-l="/Program"
                    prepopulate
                    clearable />
            </b-col>
            <b-col>
                <fg-input label="Order Number" v-model.number="order.poNumber" type="number" required />
            </b-col>
        </b-row>
        <hr />
        <b-row v-show="order.vendor && order.vendor.id && order.vendor.id != 0">
            <b-col>
                <SearchComponent v-model="drug"
                    label="Drug"
                    :search-u-r-l="`/EDIOrdering/OrderableDrugs/${order.vendor.id}`" />
            </b-col>
            <b-col>
                <fg-input label="Quantity" type="number" v-model.number="quantity" />
            </b-col>
        </b-row>
        <b-row>
            <b-col>
                <b-button variant="info" @click="addProduct">Add Product</b-button>
            </b-col>
        </b-row>
        <b-row>
            <b-col>
                <b-table :items="order.lineItems"
                    :fields="fields"
                    striped
                    show-empty
                    empty-text="No line items added to this order yet" />
            </b-col>
        </b-row>

        <b-row>
            <b-col>
                <b-button variant="success" @click="saveOrder">Save</b-button>
            </b-col>
        </b-row>

    </div>
</template>

<script lang="ts">
import { Component, Emit, Vue } from "vue-property-decorator";
import SearchComponent from "@/components/SearchComponent.vue";
import { Program } from "@/models/Program";
import { EDIOrder, EDIOrderLineItem, OrderableDrug } from "@/models/EDI/EDIOrder";
import axios from "axios";
import { NotificationOptions } from "@/util/NotificationOptionsPresets";
import { DrugSource } from "@/models/Drug/DrugProduct";
import { BvTableFieldArray } from "bootstrap-vue";
import TextUtils from "@/util/TextUtils";

@Component({
    name: "CreatePurchaseOrderForm",
    components: { SearchComponent },
})
export default class CreatePurchaseOrderForm extends Vue {
    private order: EDIOrder = new EDIOrder();

    private program: Program = new Program();

    private drug: OrderableDrug = new OrderableDrug();
    private quantity: number = 0;

    private fields: BvTableFieldArray = [
        { key: "drugName" },
        {
            key: "drugSource",
            formatter: value => DrugSource[value].toString(),
        },
        { key: "packagesOrdered" },
        {
            key: "ndC11",
            label: "NDC",
        },
        {
            key: "unitPrice",
            formatter: value => TextUtils.currencyFormatter(value),
        },
    ];

    addProduct() {
        if (!this.drug || this.drug.ndC11 == "" || !this.quantity) return;
        let item = EDIOrderLineItem.fromOrderableDrug(this.drug, this.quantity);
        this.order.lineItems.push(item);
        this.quantity = 0;
        this.drug = new OrderableDrug();
    }

    @Emit('order-saved')
    async saveOrder() {
        try {
            this.order.storeId = this.order.store.id as number;
            this.order.vendorId = this.order.vendor.id as number;
            const resp = await axios.post<EDIOrder>("/EdiOrdering", this.order);
            const ediOrder = new EDIOrder(resp.data);
            this.$notification(NotificationOptions.successSaveNotificationPreset("EDI Order"));
            return ediOrder;
        } catch (err) {
            this.$notification(NotificationOptions.error(err));
            return err;
        }
    }
}
</script>

<style scoped>

</style>
